import { useState, useEffect } from "react";
import { Container, Typography, Grid, TextField } from "@mui/material";
import { Helmet } from "react-helmet";
import { withSnackbar } from "notistack";
import { Box, Button } from "@mui/material";
import { useNewPatientContext } from "../store/NewPatientContextProvider";
import { useHistory } from "react-router-dom";
import { useDataLists } from "../store/DataListsContextProvider";
import { setPatientToInit } from "../store/action-reducers";
import {
  getStudiesByAccession,
  updateStudy,
  updateStudyWithAccession,
} from "../api/api";

function CashPayment(props) {
  const history = useHistory();
  if (!localStorage.getItem("current-procedure"))
    history.push("/global-worklist");
  const { newPatient, newPatientDispatch } = useNewPatientContext();
  const [isSaving, setSaving] = useState(false);
  const [form, setForm] = useState(
    JSON.parse(localStorage.getItem("current-procedure")).CashPayment
      ? JSON.parse(localStorage.getItem("current-procedure")).CashPayment
      : []
  );

  const handleFormChange = (index, event) => {
    console.log("event",event)
    let data = [...form];
    data[index][event.target.name] = event.target.value;
    setForm(data);
  };
  console.log("props.procedure", form);

  const addFields = () => {
    let newfield = {
      FirstName: JSON.parse(localStorage.getItem("current-procedure"))
        .FirstName,
      LastName: JSON.parse(localStorage.getItem("current-procedure")).LastName,
      Title: JSON.parse(localStorage.getItem("current-procedure")).Title,
      ReceiptType: "",
      ReceiptNumber: "",
      Reference: "",
      Ammount: 0,
    };
    setForm([...form, newfield]);
  };

  const RemoveFields = (i) => {
    let data = [...form];
    let newExam = data.filter((exam) => {
      if (exam.ReceiptNumber != data[i].ReceiptNumber) {
        return exam;
      }
    });
    setForm(newExam);
  };


  const handleSubmit = async () => {
    setSaving(true);
    let exit = false
    form.map(item =>{
      if (
        !item.ReceiptType ||
        !item.ReceiptNumber ||
        !item.Reference ||
        !item.Ammount
      ) {
        props.enqueueSnackbar("PLEASE Fill In All Fields", {
          preventDuplicate: true,
          variant: "error",
        });
        setSaving(false);
        exit = true;
      }
    })
    
    if (exit) {
      return
    }

    let [res, err] = await getStudiesByAccession(
      JSON.parse(localStorage.getItem("current-procedure")).AccessionNumber
    );
    if (err) {
      props.enqueueSnackbar(`There was an error saving this payment [${err}]`, {
        preventDuplicate: true,
        variant: "error",
      });
      setSaving(false);
      return;
    }

    res.data.map((study) => {
      study.CashPayment = form;

      updateStudy(study);
    });

    setSaving(false);
    history.push("/worklist");
    console.log("res", res);
  };

  return (
    <>
      <Helmet>
        <title>Create Receipt</title>
      </Helmet>

      <Container style={{ padding: 20 }} maxWidth="md">
        <Typography
          variant="h5"
          gutterBottom
          sx={{ mb: 3, color: "#fff", opacity: 0.8 }}
          component="div"
        >
          Create Receipt
        </Typography>

        <Button
          variant="outlined"
          onClick={addFields}
          color="secondary"
          size="small"
        >
          Add A Receipt
        </Button>

        {form.map((receipt, index) => {
          console.log("the index",index)
          return (
            <div key={index}>
              <br />
              <br />
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    label="First Name"
                    variant="outlined"
                    name="FirstName"
                    disabled={true}
                    value={receipt.FirstName}
                    fullWidth
                    onChange={(event) => handleFormChange(index, event)}
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    label="Last Name"
                    variant="outlined"
                    name="LastName"
                    disabled={true}
                    value={receipt.LastName}
                    onChange={(event) => handleFormChange(index, event)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    select
                    label="Receipt Type"
                    variant="outlined"
                    name="ReceiptType"
                    value={receipt.ReceiptType}
                    disabled={
                      JSON.stringify(
                        JSON.parse(localStorage.getItem("current-procedure"))
                          .CashPayment
                      ) === "{}"
                    }
                    fullWidth
                    onChange={(event) => handleFormChange(index, event)}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option defaultChecked key="blank" value=""></option>
                    <option defaultChecked key="No" value="Cash">
                      Cash
                    </option>
                    <option key="yes" value="EFT">
                      {" "}
                      EFT
                    </option>
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Receipt Number"
                    variant="outlined"
                    name="ReceiptNumber"
                    value={receipt.ReceiptNumber}
                    disabled={
                      JSON.stringify(
                        JSON.parse(localStorage.getItem("current-procedure"))
                          .CashPayment
                      ) === "{}"
                    }
                    onChange={(event) => handleFormChange(index, event)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    label="Reference"
                    variant="outlined"
                    name="Reference"
                    value={receipt.Reference}
                    disabled={
                      JSON.stringify(
                        JSON.parse(localStorage.getItem("current-procedure"))
                          .CashPayment
                      ) === "{}"
                    }
                    onChange={(event) => handleFormChange(index, event)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    label="Ammount"
                    variant="outlined"
                    name="Ammount"
                    value={receipt.Ammount}
                    disabled={
                      JSON.stringify(
                        JSON.parse(localStorage.getItem("current-procedure"))
                          .CashPayment
                      ) === "{}"
                    }
                    onChange={(event) => handleFormChange(index, event)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4}>
                <Button
                    variant="outlined"
                    onClick={() => RemoveFields(index)}
                    color="primary"
                    size="small"
                  >
                    Remove Exam
                  </Button>
                </Grid>
              </Grid>
            </div>
          );
        })}

        <br />

        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                color="primary"
                variant="outlined"
                size="large"
                onClick={() => {
                  newPatientDispatch(setPatientToInit());
                  history.push("/worklist");
                }}
                disabled={isSaving}
                sx={{ mr: 2 }}
              >
                Cancel
              </Button>

              <Button
                color="secondary"
                variant="contained"
                size="large"
                onClick={handleSubmit}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default withSnackbar(CashPayment);
